(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash"], factory);
	else if(typeof exports === 'object')
		exports["viewerScript"] = factory(require("lodash"));
	else
		root["viewerScript"] = factory(root["_"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__252__) => {
return 